module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/pickup-2-6707e9dafb7962fed1d855f738f0ca16.png";